import gql from 'graphql-tag'

import { PlanStructure, Regime } from '../../../../types/fam-graphql'
import { mutationServiceCreator } from '../../../../helpers/GraphqlHelpers'
import { ReducedUserPlanFragment } from '../../../fragments/ReducedUserPlanFragment'

const mutation = gql`
  mutation drawPlan($season: Season, $previous: ID) {
    drawPlan(season: $season, previous: $previous) {
      ...ReducedUserPlanFragment
    }
  }
  ${ReducedUserPlanFragment}
`

const transformer = ({ drawPlan }: any) => drawPlan

type variables = {
  preferences?: {
    express: boolean
    portions: number
    regime: Regime
    structure: PlanStructure
  }
  objectives?: {
    complete_carbohydrate: number
    dried_vegetable: number
    fish: number
    fruit_and_vegetable: number
    meat: number
    sugary_product: number
  }
  season?: string
  previous?: string
}

export default mutationServiceCreator<variables>(mutation, transformer)
